module.exports = __webpack_public_path__ + "img/row-srp-preview-infiniti.46c36ce4.png";